import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
export interface InputCategory {
    id?: string;
    name: string;
}
export const INPUT_CATEGORIES_COLLECTION = 'input-categories';
export const inputCategoriesRef = collection(firestore, INPUT_CATEGORIES_COLLECTION);
